import { render } from "./ForgottenPasswordForm.vue?vue&type=template&id=014a7374&scoped=true"
import script from "./ForgottenPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgottenPasswordForm.vue?vue&type=script&lang=js"

import "./ForgottenPasswordForm.vue?vue&type=style&index=0&id=014a7374&scoped=true&lang=css"
import "./ForgottenPasswordForm.vue?vue&type=style&index=1&id=014a7374&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014a7374"]])

export default __exports__